import { useEffect }           from 'react'
import { useFocusSet, useGet } from 'state/jotai'
import { useFetch }            from 'hooks/fetch/useFetch'
import { _lowerQualityIsometry } from 'state/store.lowerQualityIsometry'
import { _bootstrap }          from 'state/store.bootstrap'
import { array }               from 'utilities/utility.misc'
import { preloadImage }        from 'utilities/utility.images'
import { ISO_FRAMES, ISO_CONFIG } from 'api/api'
import { active_project }      from 'state/store.global'

export const PreloadFramesLowerQuality_Mono = () => {

  const type   = useGet(_bootstrap).type
  const file   = 'main/Mono/MonoPreload.jsx'
  const mono   = type === 'mono'
  const url    = ISO_CONFIG
  const config = useFetch({ url, file }).D
  const cache  = useGet(_lowerQualityIsometry).status

  const { pin, pid } = useGet(active_project)

  const setFrames  = useFocusSet(_lowerQualityIsometry, 'frames')
  const setPercent = useFocusSet(_lowerQualityIsometry, 'percent')
  const setStatus  = useFocusSet(_lowerQualityIsometry, 'status')
  const setConfig  = useFocusSet(_lowerQualityIsometry, 'config')

  useEffect(() => {
    if (pin !== null && pin >= 0 && config && !['FETCHING', 'DONE'].includes(cache?.[pin]?.[pid])) {
      const i = config[pin]

      const NUM     = i.IMAGE_NUM
      const IMG_INI = i.FIRST_IMAGE
      const IMG_END = i.LAST_IMAGE
      const INI     = i.START_IMAGE
      const EXT     = i.FILE_EXT
      const SUB     = i.LOWER_QUALITY_PNG_PATH

      const FNC = x => {
        if (INI + x > IMG_END) {
          return `${ISO_FRAMES}${SUB}/${Math.abs(IMG_END - (INI + x)) + IMG_INI - 1}.${EXT}`
        } else {
          return `${ISO_FRAMES}${SUB}/${x + INI}.${EXT}`
        }
      }

      const COL = array(NUM, FNC)

      setConfig ( a => a?.map((d, j) => fn(d, j, pin, pid, i)))
      setPercent( a => a?.map((d, j) => fn(d, j, pin, pid, '0')))
      setStatus ( a => a?.map((d, j) => fn(d, j, pin, pid, 'FETCHING')))

      const loadAll = async () => {
        const ARR       = new Array(NUM)
        let loadedCount = 0
        const BATCH     = 20 // low-res frames are small, 20 concurrent is fine

        for (let start = 0; start < COL.length; start += BATCH) {
          const chunk = COL.slice(start, start + BATCH)

          await Promise.all(
            chunk.map(async (val, chunkIdx) => {
              const idx = start + chunkIdx
              try {
                const bitmap = await preloadImage(val) // fetch→blob→createImageBitmap, single decode
                ARR[idx]     = { [IMG_INI + idx]: bitmap }
              } catch {
                ARR[idx]     = { [IMG_INI + idx]: null }
              }

              loadedCount += 1
              const percent = Math.min(100, Math.floor((loadedCount / NUM) * 100)).toFixed()
              setPercent(a => a?.map((d, j) => fn(d, j, pin, pid, percent)))
            })
          )
        }

        setFrames(a => a?.map((d, j) => fn(d, j, pin, pid, ARR)))
        setStatus(a => a?.map((d, j) => fn(d, j, pin, pid, 'DONE')))
      }

      loadAll()
    }
  }, [mono, config, pin, pid])

  return null
}

const fn = (x, y, z, v, w) => (y === z) ? { [v]: w } : x